
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ProcessAssignToRunsheetPayload = {
  orderIds: EntityId[]
  runsheetId: EntityId
  sourceRunsheetId: EntityId
}

export const processAssignToRunsheet = createAsyncThunk<void, ProcessAssignToRunsheetPayload, { state: RootState }>(
  'dragdrop/processAssignToRunsheet',
  async (payload) => {
    await OLMSApiService.post<null>('/runsheet/assignToRunsheet', payload)
  },
)
